import React from "react";
import { ProductConsumer } from "../../../../Context/AddProWakel";
import Time from "react-time-format";
const FirstRow = () => {
  return (
    <>
      <ProductConsumer>
        {(value) => {
          const {
            AddProChange,
            R_zh_wasl,
            R_search_wasl,
            R_date,
            R_del_dis,
            getWaslDataBySearchRent,
            R_zh_wasl_katy,
            R_togler,
            R_save,
            inputtogler,
            R_table,
            R_open,
            R_wasl
          } = value;
          const renderdate = (kat) => {
            const monthname = [
              "1",
              "2",
              "3",
              "4",
              "5",
              "6",
              "7",
              "8",
              "9",
              "10",
              "11",
              "12"
            ];
            const date = new Date(kat);

            return `${date.getDate()}/${
              monthname[date.getMonth()]
            }/${date.getFullYear()}`;
          };
          return (
            <>
              <div className="row">
                <div className="col-1 text-right mt2">
                  <button
                    disabled={R_del_dis == true ? true : null}
                    onClick={inputtogler}
                    className="btn btn-info mt4"
                  >
                    <i className="far fa-calendar-alt white "></i>
                  </button>
                </div>

                <div
                  className={`${
                    R_togler == true
                      ? "col-sm-6 text-right"
                      : "col-sm-3 text-right"
                  }`}
                >
                  <div className="form-group">
                    <label className="font-weight-bold f4">بەروار</label>
                    {R_togler == false ? (
                      <input
                        type="text"
                        name="R_date"
                        value={
                          R_search_wasl == true || R_save == true
                            ? renderdate(R_date)
                            : renderdate(Date.now())
                        }
                        className="form-control text-right font-weight-bold"
                      />
                    ) : (
                      <input
                        type="datetime-local"
                        name="R_date"
                        value={R_date}
                        onChange={AddProChange}
                        className="form-control text-right font-weight-bold tc btn btn-info"
                        style={{ margin: "0px 8px" }}
                      />
                    )}
                  </div>
                </div>
                {R_togler == false ? (
                  <div className="col-sm-3 text-right">
                    <div className="form-group">
                      <label className="font-weight-bold f4">کات</label>
                      {R_search_wasl == true || R_save == true ? (
                        <p className="font-weight-bold bg-white p-2 border rounded tc">
                          <Time
                            value={R_wasl.date}
                            format="hh:mm:ss"
                            style={{ color: "black" }}
                          />
                        </p>
                      ) : (
                        <p className="font-weight-bold bg-white p-2 border rounded tc">
                          <Time
                            value={Date.now()}
                            format="hh:mm:ss"
                            style={{ color: "black" }}
                          />
                        </p>
                      )}
                    </div>
                  </div>
                ) : null}

                <div className="col-sm-2 text-right">
                  <div className="form-group">
                    <label className="font-weight-bold f4">ژمارە</label>
                    <input
                      type="number"
                      name="R_zh_wasl"
                      disabled={R_open == true || R_table == true ? true : null}
                      value={R_zh_wasl}
                      onKeyPress={(event) =>
                        event.key == "Enter"
                          ? getWaslDataBySearchRent(event)
                          : null
                      }
                      onChange={AddProChange}
                      className={`form-control text-right font-weight-bold ${
                        R_search_wasl == true || R_save == true
                          ? "bg-danger text-white"
                          : ""
                      }`}
                    />
                  </div>
                </div>
                <div className="col-sm-3 text-right">
                  <div className="form-group">
                    <label className="font-weight-bold f4">پسوولە</label>
                    <input
                      type="text"
                      value={R_zh_wasl_katy}
                      className="form-control text-right font-weight-bold font-weight-bold  bg-success text-white"
                    />
                  </div>
                </div>
              </div>
            </>
          );
        }}
      </ProductConsumer>
    </>
  );
};
export default FirstRow;
